/* ==========================================================================
   31st — Cart
   Talks to Shopify's real Cart AJAX API and re-renders the drawer through
   the Section Rendering API, so the markup stays in Liquid.
   ========================================================================== */
(function () {
  'use strict';

  var S = (window.st31 && window.st31.strings) || {};
  var DRAWER_SECTION = '31st-cart-drawer';

  function routeWithSections(base) {
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'sections=' + encodeURIComponent(DRAWER_SECTION) +
           '&sections_url=' + encodeURIComponent(window.location.pathname);
  }

  function swapDrawer(sections) {
    if (!sections || !sections[DRAWER_SECTION]) return;
    var parsed = new DOMParser().parseFromString(sections[DRAWER_SECTION], 'text/html');
    var fresh = parsed.querySelector('[data-st31-cart-root]');
    var current = document.querySelector('[data-st31-cart-root]');
    if (fresh && current) current.replaceWith(fresh);
  }

  function updateCount(count) {
    document.querySelectorAll('[data-st31-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-empty', count > 0 ? 'false' : 'true');
    });
  }

  function refreshCount() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; })
      .catch(function () {});
  }

  function setButtonState(btn, text, busy) {
    if (!btn) return;
    var label = btn.querySelector('[data-st31-add-label]') || btn;
    if (busy) {
      btn.dataset.st31Prev = label.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    } else {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
    if (text) label.textContent = text;
  }

  function showFormError(form, message) {
    var box = form.querySelector('[data-st31-form-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
  }

  function addFromForm(form) {
    var btn = form.querySelector('[type="submit"]');
    var prevLabel = (form.querySelector('[data-st31-add-label]') || {}).textContent;

    showFormError(form, '');
    setButtonState(btn, null, true);

    var body = new FormData(form);
    body.append('sections', DRAWER_SECTION);
    body.append('sections_url', window.location.pathname);

    return fetch(S.cartAddUrl || '/cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok) {
          // Shopify returns { description, message } on a rejected add
          showFormError(form, r.data.description || r.data.message || S.cartError || 'Could not add to cart.');
          setButtonState(btn, prevLabel, false);
          return;
        }
        swapDrawer(r.data.sections);
        setButtonState(btn, prevLabel, false);
        refreshCount();
        if (window.st31 && window.st31.Drawer) window.st31.Drawer.open('cart');
        document.dispatchEvent(new CustomEvent('st31:cart:updated'));
      })
      .catch(function () {
        showFormError(form, S.cartError || 'Could not add to cart.');
        setButtonState(btn, prevLabel, false);
      });
  }

  function changeLine(line, quantity) {
    var root = document.querySelector('[data-st31-cart-root]');
    if (root) root.setAttribute('data-busy', 'true');

    return fetch(S.cartChangeUrl || '/cart/change', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: DRAWER_SECTION,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        swapDrawer(data.sections);
        updateCount(data.item_count);
        document.dispatchEvent(new CustomEvent('st31:cart:updated'));
        // The full cart page mirrors the drawer, so keep it in step
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(function () {
        if (root) root.removeAttribute('data-busy');
      });
  }

  /* ------------------------------------------------------------ bindings */
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-st31-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(Number(remove.getAttribute('data-st31-cart-remove')), 0);
      return;
    }

    var step = e.target.closest('[data-st31-cart-step]');
    if (step) {
      e.preventDefault();
      var line = Number(step.getAttribute('data-line'));
      var next = Number(step.getAttribute('data-to'));
      if (next >= 0) changeLine(line, next);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-st31-cart-qty]');
    if (!input) return;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine(Number(input.getAttribute('data-line')), qty);
  });

  window.st31 = window.st31 || {};
  window.st31.cart = {
    addFromForm: addFromForm,
    changeLine: changeLine,
    refreshCount: refreshCount
  };
})();
